// extracted by mini-css-extract-plugin
module.exports = {"greenText":"print-price_greenText__SpErB","largeText":"print-price_largeText__2ofA2"};